import { DialogType } from '../../components/dialog/search/DemoDialog';
import ClientsAxios from '../client-axios';
import { TokenRequest } from '../dto/request';
import { DemoAndPriceEnquiryRequest } from '../dto/request/chat';
import { ResponseEntity, TokenResponse } from '../dto/response';
import { DemoAndPriceEnquiryResponse, FetchAddResponse, FetchBlogsResponse, FetchNewsResponse, TractorApiResponse, TractorData } from '../dto/response/chat';

const { API_SERVER, THIRD_PARTY_API_SERVER } = ClientsAxios;

export const tokenService = async (formData: FormData) => {
    const responseEntity = new ResponseEntity<TokenResponse>()
    try {
        const response = await API_SERVER.post('token', formData, {
            headers: {
                "content-Type": "multipart/form-data",
            },
        });
        responseEntity.success(response.data.body, 200, response.data.message)

    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchChatService = async (payload: any, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<TractorData>()
    try {
        const response = await API_SERVER.post('/chat', payload, { signal })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchAddService = async (payload: any, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<FetchAddResponse>()
    try {
        const response = await API_SERVER.get('/ads/images', payload, { signal })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchDropdownService = async (payload: any, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('/dropdown', payload, { signal })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchStatesService = async (payload: any, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await THIRD_PARTY_API_SERVER.get('webApi/states', payload, { signal })
        responseEntity.success(response.data, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchCitiesService = async (payload: any, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const url = payload?.state_id
            ? `webApi/cities/${payload.state_id}`
            : 'webApi/cities';

        const response = await THIRD_PARTY_API_SERVER.get(url, payload, { signal })
        responseEntity.success(response.data, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchTalukaService = async (payload: any, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const url = payload?.city_id
            ? `webApi/taluka/${payload.city_id}`
            : 'webApi/taluka';
        const response = await THIRD_PARTY_API_SERVER.get(url, payload, { signal })
        responseEntity.success(response.data, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}


export const RequestDemoEnquiryService = async (payload: DemoAndPriceEnquiryRequest, endpointSlug: string, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<DemoAndPriceEnquiryResponse>()
    try {
        const response = await THIRD_PARTY_API_SERVER.post(endpointSlug, payload, { signal });
        responseEntity.success(response.data.body, 200, response.data.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchBlogsService = async (payload: { search: string }, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<FetchBlogsResponse>()
    try {
        const response = await THIRD_PARTY_API_SERVER.post('/ai/wp/blog', payload, { signal });
        responseEntity.success(response.data, 200, response.data.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}
export const FetchNewsService = async (payload: { search: string }, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<FetchNewsResponse>()
    try {
        const response = await THIRD_PARTY_API_SERVER.post('/ai/wp/news', payload, { signal });
        responseEntity.success(response.data, 200, response.data.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}